import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';

interface PrivateRouteProps {
    hasToken: boolean
}

export const PrivateRoute = ({hasToken}: PrivateRouteProps) => {
    const { search } = useLocation();
    return hasToken ? <Outlet/> : <Navigate to={`/sign-in${search}`}/>;
}